import { render, staticRenderFns } from "./DragDropFiles.vue?vue&type=template&id=34eaa4e0&scoped=true&"
import script from "./DragDropFiles.vue?vue&type=script&lang=ts&"
export * from "./DragDropFiles.vue?vue&type=script&lang=ts&"
import style0 from "./DragDropFiles.vue?vue&type=style&index=0&id=34eaa4e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34eaa4e0",
  null
  
)

export default component.exports